import { render, staticRenderFns } from "./UserValidationCard.vue?vue&type=template&id=22597df6&scoped=true&"
import script from "./UserValidationCard.vue?vue&type=script&lang=js&"
export * from "./UserValidationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22597df6",
  null
  
)

export default component.exports